import '../../../style/mobile/store/MspTab1.scss';
import video1 from '../../../../assets/store/video.mp4';
import { FaPlay } from 'react-icons/fa';


const MspTab1=({data})=>{
  const playVideo=()=>{
    document.querySelector(".MspTab1-about-item-video-continer-video").play();
    document.querySelector(".MspTab1-about-item-video-continer-cover").style.display="none";
  }
  return(
    <div className="MspTab1">
      <div className="MspTab1-buy-count-box">
        <div className="MspTab1-buy-count-box-text">
          <div className="MspTab1-buy-count-box-text-title">تعداد خرید محصول</div>
          <div className="MspTab1-buy-count-box-text-subtitle">
            بیشتر از <span>{data.count}</span> نفر در این آزمون شرکت خواهندکرد
          </div>
        </div>
        <div className="MspTab1-buy-count-box-circles">
          <div style={{backgroundColor:"#7FD8F3"}} className="MspTab1-buy-count-box-circles-item"></div>
          <div style={{backgroundColor:"#7F92F3",left:"10%"}}className="MspTab1-buy-count-box-circles-item"></div>
          <div style={{backgroundColor:"#E5FF3F",left:"20%"}}className="MspTab1-buy-count-box-circles-item"></div>
          <div style={{backgroundColor:"#FFD93F",left:"30%"}}className="MspTab1-buy-count-box-circles-item">
            {data.count}+
          </div>
        </div>
      </div>
      <div className="MspTab1-about">
        <div className="MspTab1-about-item">
          <div className="MspTab1-about-item-title">درباره آزمون</div>
          <div className="MspTab1-about-item-subtitle">
            {data.descripton}
          </div>
          <div className="MspTab1-about-item-title">این آزمون به درد چه کسانی می‌خورد؟</div>
          <div className="MspTab1-about-item-subtitle">
            {data.html[0]}
          </div>
          <div className="MspTab1-about-item-title">نحوه شرکت در آزمون</div>
          <div className="MspTab1-about-item-subtitle">
            {data.html[1]}
          </div>
          <div className="MspTab1-about-item-video-continer">
            <div className="MspTab1-about-item-video-continer-cover">
              <div className="MspTab1-about-item-video-continer-cover-btn" onClick={playVideo}>
                <FaPlay className="MspTab1-about-item-video-continer-cover-btn-icon"/>
              </div>
            </div>
            <video className="MspTab1-about-item-video-continer-video"  controls src={video1}></video>
          </div>
        </div>
      </div>
    </div>
  )
}


export default MspTab1;